import React, { Component } from 'react';
import OrderDetail from './OrderDetail';
import Grid from 'screens/components/basic/Grid';
import { ordersViewCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';

class OrderDetailPage extends Component {
    constructor(props) {
        super(props);
    }

    backToOrder = () => {
        this.props.navigate('/admin/orders');
    }

    render() {
        return (
            <Grid headerContent={ordersViewCrumb}>
                <OrderDetail orderId={this.props.params} />
            </Grid>
        );
    }
}

export default WithRouter(OrderDetailPage);
